module.exports = __webpack_public_path__ + "img/40.2d8a2ce3.jpg";